module.exports = __webpack_public_path__ + "static/media/Bulldog713_2c2.7959ef9d.svg";